import {
  DOCUMENT_SIGNING_GET_LIST,
  DOCUMENT_SIGNING_GET,
  DOCUMENT_SIGNING_GET_BY_SIGNER,
  DOCUMENT_SIGNING_SUBMIT,
  DOCUMENT_SIGNING_REQUEST,
  DOCUMENT_SIGNING_SUCCESS,
  DOCUMENT_SIGNING_ERROR
} from "@/store/types"

import axios from "@/store/axios"
// import _ from "lodash"

const state = {
  signings: null,
  isLoading: false,
  page: 1,
  totalCount: 0,
  error: null,
  current: null
}

const getters = {
  getDocumentSignings: (state) => state.signings,
  getCurrentDocumentSigning: (state) => state.current,
  isDocumentSigningLoading: (state) => state.isLoading,
  getDocumentSigningsCurrentPage: (state) => state.page,
  getDocumentSigningsTotalCount: (state) => state.totalCount,
  isDocumentSigningsLoading: (state) => state.isLoading,
  getDocumentSigningsError: (state) => state.error
}

const actions = {
  [DOCUMENT_SIGNING_GET]: ({ commit }, { id, token }) => {
    return new Promise((resolve, reject) => {
      commit(DOCUMENT_SIGNING_REQUEST)

      axios
        .get(`/api/v3/document_signings/${id}/${token ? `?t=${token}` : ""}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(DOCUMENT_SIGNING_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_SIGNING_ERROR, err)
          reject(err)
        })
    })
  },
  [DOCUMENT_SIGNING_GET_LIST]: ({ commit }, { page = 1 } = {}) => {
    return new Promise((resolve, reject) => {
      commit(DOCUMENT_SIGNING_REQUEST)

      axios
        .get(`/api/v3/document_signings/?page=${page}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(DOCUMENT_SIGNING_SUCCESS, { signings: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_SIGNING_ERROR, err)
          reject(err)
        })
    })
  },
  [DOCUMENT_SIGNING_GET_BY_SIGNER]: ({ commit }, { id, token } = {}) => {
    return new Promise((resolve, reject) => {
      commit(DOCUMENT_SIGNING_REQUEST)

      axios
        .get(`/api/v3/document_signings/${id}/signer/?t=${token}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(DOCUMENT_SIGNING_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_SIGNING_ERROR, err)
          reject(err)
        })
    })
  },
  [DOCUMENT_SIGNING_SUBMIT]: ({ commit }, { id, token, overlay } = {}) => {
    return new Promise((resolve, reject) => {
      commit(DOCUMENT_SIGNING_REQUEST)

      axios
        .post(`/api/v3/document_signings/${id}/submit/?t=${token}`, {
          overlay
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(DOCUMENT_SIGNING_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_SIGNING_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [DOCUMENT_SIGNING_REQUEST]: (state) => {
    state.isLoading = true
  },
  [DOCUMENT_SIGNING_SUCCESS]: (state, { signings, current } = {}) => {
    state.isLoading = false

    if (current) {
      state.current = current
    }

    if (signings) {
      state.signings = signings.results
      state.page = signings.page
      state.totalCount = signings.count
    }
  },
  [DOCUMENT_SIGNING_ERROR]: (state, err) => {
    state.isLoading = false

    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
